import { FilterSortId } from '@jane/search/data-access';
import type { FilterSortOption } from '@jane/search/data-access';

export const brandSortOptions: FilterSortOption[] = [
  {
    id: FilterSortId.Default,
    isDefault: true,
    label: 'Default',
    value: 'default',
  },
  {
    id: FilterSortId.AZ,
    isDefault: false,
    label: 'A-Z',
    value: 'a-z',
  },
  {
    id: FilterSortId.Upvote,
    isDefault: false,
    label: 'Upvotes',
    value: 'upvote',
  },
];
